import { render, staticRenderFns } from "./VPageNav.vue?vue&type=template&id=729ef2a8&"
import script from "./VPageNav.vue?vue&type=script&lang=js&"
export * from "./VPageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports